module.exports = "/images/create_account.jpg?5ade5ae9ce82b2d092d5ce1d8417d110";